export default {
    translations: {
        home: {
            message: 'Ola Mundo'
        }
    }
}